import {Component, OnInit, Input, ViewContainerRef, SimpleChanges} from '@angular/core';
import {Modal} from "angular2-modal/plugins/bootstrap";
import {State} from "../../shared/model/state";
import {Restaurant} from "../../shared/model/restaurant";
import {FormGroup, Validators, FormBuilder} from "@angular/forms";
import {Overlay} from "angular2-modal";
import {StateDataService} from "../../shared/services/state/state-data.service";
import {Router, ActivatedRoute} from "@angular/router";
import {MapsService} from "../../shared/services/maps/maps.service";

@Component({
  selector: 'restaurant-form',
  templateUrl: 'restaurant-form.component.html',
  styleUrls: ['restaurant-form.component.css'],
  providers:[Modal]
})
export class RestaurantFormComponent implements OnInit {

  states: State[];
  restaurant:Restaurant;
  submitted = false;
  restaurantId:string;

  form:FormGroup;

  @Input()
  initialValues:any;
  selectedState:string;
  selectorIsClicked:boolean;
  private edit:string = "";


  constructor(
    private formBuilder: FormBuilder,
    private stateDataservice : StateDataService,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,
    private route: ActivatedRoute,
    private mapService:MapsService
  ) {
    this.form = this.formBuilder.group({
    restaurant:['',[Validators.required,Validators.minLength(3)]],
      address:['',[Validators.required,Validators.minLength(7)]],
      city:['',[Validators.required,Validators.minLength(3)]],
      state:['',Validators.required],
      zip:['',[Validators.required,Validators.minLength(5)]],
      isActive:['', [Validators.pattern('true')]],
      latitude:['',[Validators.required,Validators.minLength(4)]],
      longitude:['',[Validators.required,Validators.minLength(4)]],


    });

    //TODO: Implement Countries


    this.states = this.stateDataservice.getStates();

    this.selectorIsClicked = false;

    overlay.defaultViewContainer = vcRef;
  }


  onGetLocation() {
    let addressIsValid =
      this.form.controls['address'].valid &&
      this.form.controls['city'].valid &&
      this.form.controls['zip'].valid;

    if (addressIsValid){
      let address = this.form.controls['address'].value + ' '+
        this.form.controls['city'].value + ' '+
        this.form.controls['zip'].value;
      address = encodeURI(address);
      this.getLatLan(address);
    }
  }

  getLatLan(address: string) {

    const coord$ = this.mapService.getLocation( address );
    coord$.subscribe( result =>{
        this.form.controls['latitude'].setValue( result.lat)
        this.form.controls['longitude'].setValue( result.lng)
        this.select(result.state);
        this.selectorIsClicked = true;
        // this.form.controls['state'].markAsDirty();
        // result => console.log(result)
      }
    );


  }


  ngOnInit() {

     // console.log(this.initialValues);
    this.selectedState = this.initialValues.state;
     this.form.controls['isActive'].setValue(this.initialValues.isActive);

    let myRoute = this.route.snapshot;


    this.restaurantId = myRoute.params['id'];

    if (!this.restaurantId){
      this.selectedState = "Select a state";
      this.form.controls['isActive'].setValue(true);

    }


  }

  messageIt(titleP:string,messageP:string){

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

  printOpening() {

  }

  printClosing() {

    this.selectorIsClicked = true;
  }

  clicked(){

    this.selectorIsClicked = true;
  }

  select(selectedState:string) {

    this.selectedState = selectedState;
    this.form.controls['state'].setValue(selectedState);
    // this.form.controls['state'].setErrors(null);

  }


  itHaveErrors(){

    const isValid = this.form.valid;

    return isValid;

  }


  showSelectorError(){
    const showError = this.selectedState == "Select a state" && this.selectorIsClicked;

    return showError;
  }


  ngOnChanges(changes:SimpleChanges){

    if (this.form && changes['initialValues']){
      this.form.patchValue(changes['initialValues'].currentValue);
    }

  }


  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  reset() {
    this.form.reset();
  }

  get valid(){
    return this.form.valid;
  }

  get value(){
    return this.form.value;
  }


  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
    if (this.selectedState === "Select a state"){
      this.selectorIsClicked = true;
      this.form.controls['state'].markAsDirty();
    }

  }


  setBlank(){

    this.form.reset();
    this.selectedState = this.initialValues.state;
    this.form.controls['isActive'].setValue(true);
    this.selectorIsClicked = false;
  }



}



// WEBPACK FOOTER //
// ./src/app/restaurant/restaurant-form/restaurant-form.component.ts